export default {"src":"/_next/static/media/black-scale.bcff9de5.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};